import { render, staticRenderFns } from "./kindChooseViewsPartner.vue?vue&type=template&id=6f5e35d1&scoped=true"
import script from "./kindChooseViewsPartner.vue?vue&type=script&lang=js"
export * from "./kindChooseViewsPartner.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViewsPartner.vue?vue&type=style&index=0&id=6f5e35d1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5e35d1",
  null
  
)

export default component.exports